<template>
  <b-card class="card" no-body>
    <b-container class="template">
      <b-row class="title-row-margin">
        <b-col cols="12">
          <div class="service-title">
            Services
          </div>
        </b-col>
      </b-row>
      <b-row class="service-section">
        <b-container>
          <b-row v-for="(serviceRow, idx) in services" :key="idx" class="service-container-row">
            <b-col v-for="service in serviceRow" :key="service.name" xl="4" lg="4" md="12" sd="12" xs="12">
              <router-link :to="{ name: service.routeName }" exact class="service-container">
                <div
                  class="service-wrapper"
                  @click="trackCustomEvent({ inPage: routeName, action: 'clicked', target: 'services_home_page', linkTo: service.routeName })"
                >
                  <div class="icon-container">
                    <img :src="service.icon">
                  </div>
                  <div class="service-name">
                    <div class="name">
                      {{ service.name }}
                    </div>
                    <div class="description">
                      {{ service.desc }}
                    </div>
                  </div>
                </div>
              </router-link>
            </b-col>
          </b-row>
        </b-container>
      </b-row>
    </b-container>
  </b-card>
</template>

<script>
import { BCard, BContainer, BRow, BCol } from 'bootstrap-vue'
import { mapActions } from 'vuex'

export default {
  name: 'NLPServiceCard',
  components: {
    BContainer,
    BRow,
    BCol,
    BCard
  },
  data () {
    return {
      services: [
        [
          {
            name: 'แกะที่อยู่จากข้อความ',
            desc: 'ค้นหา ชื่อผู้รับ ตำบล อำเภอ จังหวัด ในข้อความ',
            routeName: 'demo-address',
            icon: '/assets/media/icons/address_extract.png'
          },
          {
            name: 'ระบุประเทศในที่อยู่',
            desc: 'ค้นหาชื่อประเทศในข้อความ',
            routeName: 'demo-country',
            icon: '/assets/media/icons/country.png'
          },
          {
            name: 'ตัดคำ',
            desc: 'แบ่งประโยคออกเป็นคำ',
            routeName: 'demo-tokenize',
            icon: '/assets/media/icons/word_cut.png'
          }
        ],
        [
          {
            name: 'Sentiment',
            desc: 'วิเคราะห์อารมณ์ในข้อความ',
            routeName: 'demo-sentiment',
            icon: '/assets/media/icons/sentiment.png'
          },
          {
            name: 'Cleansing',
            desc: 'เปลี่ยนประโยคให้อยู่ในรูปแบบที่กระทัดรัดมากขึ้น',
            routeName: 'demo-cleansing',
            icon: '/assets/media/icons/cleansing.png'
          },
          {
            name: 'Clustering',
            desc: 'จัดกลุ่มของประโยค',
            routeName: 'demo-clustering',
            icon: '/assets/media/icons/clustering.png'
          }
        ],
        [
          {
            name: 'Datetime parser',
            desc: 'เปลี่ยนคำบอกเวลาเป็น timestamp',
            routeName: 'demo-datetime',
            icon: '/assets/media/icons/date_time.png'
          },
          {
            name: 'Similar',
            desc: 'ค้นหาคำที่เกี่ยวข้อง',
            routeName: 'demo-similar',
            icon: '/assets/media/icons/similar.png'
          },
          {
            name: 'แก้คำผิด',
            desc: 'ตรวจหาคำผิดและแนะนำคำที่ถูกต้อง',
            routeName: 'demo-spell',
            icon: '/assets/media/icons/spell_check.png'
          }
        ],
        [
          {
            name: 'Classification',
            desc: 'แยกประเภทข้อความ',
            routeName: 'demo-classification',
            icon: '/assets/media/icons/classification.png'
          },
          {
            name: 'OCR',
            desc: 'ค้นหาข้อความในรูปภาพ',
            routeName: 'demo-ocr',
            icon: '/assets/media/icons/ocr.png'
          }
        ]
      ]
    }
  },
  computed: {
    routeName () {
      return this.$route.name
    }
  },
  methods: {
    ...mapActions({
      trackCustomEvent: 'trackCustomEvent'
    })
  }
}
</script>

<style lang="scss" scoped>

    .card {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 5px 20px #523F690D;
        border-radius: 4px;
        opacity: 1;
        width: 100%;
        height: 100%;
        padding: 48px;
    }

    .service-title {
        color: #48465B;
        opacity: 1;
        font-size: 26px;
        font-weight: 600;
        text-align: center;
    }

    .title-row-margin {
        margin-bottom: 28px;
    }

    @media (max-width: 1025px) {
        [class*="service-col col-"] {
            margin-bottom: 60px;
        }
    }

    .service-section {
        margin-bottom: 48px;
    }

    .home-content {
        display: flex;
        justify-content: center;
    }

    .service-container {
        /*display: flex;*/
        /*justify-content: center;*/
        /*margin: 2em;*/
        /*width: 300px;*/
        .service-wrapper {
          display: flex;
          justify-content: center;
          margin: 2em;
            .service-name {
                margin-left: 1.5em;
                width: 150px;
                text-align: left;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .name {
                    font-size: 16px;
                    font-weight: bold;
                    color: #48465B;
                }

                .description {
                    font-size: 14px;
                    color: #9392A0;
                }
            }

            .icon-container {
                background: #6F4FFF;
                width: 70px;
                height: 70px;
                padding: 18px;
                border-radius: 8px;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 100%;
                }
            }
        }

    }

    .service-list-container {
        background: transparent;
        color: #48465B;
        padding: 0 2em 2em 2em;
        margin-top: 4em;
        /*box-shadow: 0px 5px 20px #523F690D;*/
        border-radius: 4px;

        h1 {
            font-size: 26px;
            margin: 48px 0;
        }

        .service-container-row {
            display: flex;

        }
    }

    @media (max-width: 900px) {
        .service-container-row {
            flex-direction: column;
        }
        .service-container {
            margin: 2em 0 !important;
        }
    }

    @media (max-width: 500px) {
        .content {
            margin-top: 0px;
        }
        h2 {
            margin-bottom: 0.6em;
            font-size: 1.7em;
        }
    }

    @media (max-width: 1240px) {
        .service-list-container {
            padding: 0;
            margin-top: 40px;
        }
        .banner-container {
            height: initial;
            background: #6F4FFF;

            .banner-text {
                padding: 2em;
                text-align: left;
                margin-left: 0;

                /*h1 {*/
                /*    color: white;*/
                /*}*/

                /*h2 {*/
                /*    color: white;*/
                /*}*/
            }
        }
    }
</style>
